<template>
  <div class="coverLayout" v-if="dialogGuide">
    <div class="coverBox">
      <i class="cover_tl"></i>
      <i class="cover_rb"></i>
      <i class="icon_close" @click="handleClose"></i>
      <div class="coverTitle">
        <span>新手引导</span>
      </div>
      <div class="coverContent">
        <!-- <ul>
          <li>
            <div>查看：</div>
            <div>
              为了准确匹配和查看数据档案，请您先完成实名认证，确认本人身份
            </div>
          </li>
          <li>
            <div>自填：</div>
            <div>您可以通过自填的方式补充填写您的数据档案。</div>
          </li>
          <li>
            <div>勘误：</div>
            <div>
              若您对数据档案中的具体数据有异议，可向数据来源方申请勘误。
            </div>
          </li>
          <li>
            <div>生成个人信息报告：</div>
            <div>
              您可以从数据档案中勾选必要信息生成个人信息报告，通过电子证书授权他人查看。
            </div>
          </li>
        </ul> -->
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dialogGuide", "dialogGuideClose"],
  data() {
    return {
      // dialogGuide: true
    };
  },
  methods: {
    handleClose() {
      console.log("handleClose");
      this.$emit("dialogGuideClose", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.coverLayout {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  .coverBox {
    // margin: 0 auto;
    padding: 32px 74px 61px 74px;
    border-radius: 16px;
    width: 464px;
    // height: 555px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/guide_bg.png") no-repeat;
    background-size: contain;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    .cover_tl {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cover_tl.png") no-repeat;
      background-size: cover;
      width: 85px;
      height: 50px;
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
    }
    .cover_rb {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cover_rb.png") no-repeat;
      background-size: cover;
      width: 103px;
      height: 67px;
      display: inline-block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .coverTitle {
      text-align: center;
      font-size: 20px;
      color: #3a61b1;
      margin-bottom: 57px;
    }
    .coverContent {
      // line-height: 24px;
      ul {
        list-style: none;
        li {
          margin-bottom: 30px;
          &:last-child {
            margin-bottom: 0;
          }
          div {
            color: #6e6e6e;
            font-size: 16px;
            &:first-child {
              color: #3a61b1;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .icon_close {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_close.png") no-repeat;
      background-size: cover;
      display: inline-block;
      width: 14px;
      height: 14px;
      position: absolute;
      right: 20px;
      top: 21px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cover.vue